import { render, staticRenderFns } from "./TambahEmployeeWorkplace.vue?vue&type=template&id=3cf9b575&scoped=true"
import script from "./TambahEmployeeWorkplace.vue?vue&type=script&lang=js"
export * from "./TambahEmployeeWorkplace.vue?vue&type=script&lang=js"
import style0 from "./TambahEmployeeWorkplace.vue?vue&type=style&index=0&id=3cf9b575&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf9b575",
  null
  
)

export default component.exports